export const ROOT = '/';
export const MEMORY_ROUTE = '/:personId/memory/:memoryId';
